module.exports = __webpack_public_path__ + "static/media/cq_mostra.10f9d54e.svg";